export const CRITERIA_DESCRIPTION = "CRITERIA_DESCRIPTION";
export const RATING_DESCRIPTION = "RATING_DESCRIPTION";
export const CODE = "CODE";
export const GRADE_SCALE_VALUE = "GRADE_SCALE_VALUE";

export const DISPLAY_OPTIONS = {
  STANDARD_BASED_RUBRIC: [
    {
      value: CODE,
      label: "common:code",
    },
    {
      value: RATING_DESCRIPTION,
      label: "common:description",
    },
    {
      value: GRADE_SCALE_VALUE,
      label: "worksheet:label",
    },
  ],
  SCORE_BASED_RUBRIC: [
    {
      value: CRITERIA_DESCRIPTION,
      label: "common:criteria_description",
    },
    {
      value: RATING_DESCRIPTION,
      label: "common:rating_description",
    },
  ],
};

export const SCORE_BASED_RUBRIC_ROW = "SCORE_BASED_RUBRIC_ROW";
export const SCORE_BASED_RUBRIC_COLUMN = "SCORE_BASED_RUBRIC_COLUMN";
export const ROW_CELL_CONTAINER = "ROW_CELL_CONTAINER";

export const DEFAULT_CRITERION_INPUT = {
  label: "",
  description: "",
  descriptors: [
    {
      label: "",
      description: "",
      displaySequence: 1,
    },
    {
      label: "",
      description: "",
      displaySequence: 2,
    },
    {
      label: "",
      description: "",
      displaySequence: 3,
    },
    {
      label: "",
      description: "",
      displaySequence: 4,
    },
  ],
};

export const STANDARD_RUBRIC_DISPLAY_SETTINGS = {
  SCORE_BASED_RUBRIC: "ScoreBasedRubricDisplaySetting",
  STANDARD_BASED_RUBRIC: "StandardBasedRubricDisplaySetting",
};

export const SPLIT_VIEW_DESCRIPTION = "SPLIT_VIEW_DESCRIPTION";
